import React, { useEffect, useState } from "react";
import FirstButton from "../common/button";
import BreadCrumbs from "./BreadCrumbs";
import api from "../Axios";
import { useNavigate, useParams } from "react-router-dom";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import StarsIcon from "@mui/icons-material/Stars";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Card } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ApiImage from "../assets/images/API Supplier API.png";
import frontEndImg from "../assets/images/Front end markets.png";
import ScienceIcon from "@mui/icons-material/Science";
import CapacityImage from "../assets/images/Capacity.png";
import PushPinIcon from "@mui/icons-material/PushPin";
import noData from "../assets/images/noData.png";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
const SupplierDetails = () => {
  let { id } = useParams();

  const urls = [
    { name: "Home", url: "/home" },
    { name: "Supplier Search", url: "/supplier-search" },
    { name: "Supplier Details", url: "" },
  ];
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [relateddata, setRelatedData] = useState([]);
  const [dataaccordian, setDataaccordian] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (newValue) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    // debugger;
    // window.scrollTo(0, 0); // Scrolls to the top of the page
    getSupplierDetails();
    getRelatedDossierDetails();
  }, [id]);

  const getSupplierDetails = () => {
    const data = { id: id };
    api
      .post("get-supplierbyid", data)
      .then((resp) => {
        setData(resp?.data?.data);

        let data = transformBackendData(resp?.data?.data);
        setDataaccordian(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRelatedDossierDetails = () => {
    const data = { id: id };
    api
      .post("get-productcode", data)
      .then((resp) => {
        setRelatedData(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const transformBackendData = (backendData) => {
    // Extract real tab names from the backend data
    const dosageForms = [
      backendData.SuListing_Production_capabilities_dosageform1,
      backendData.SuListing_Production_capabilities_dosageform2,
      backendData.SuListing_Production_capabilities_dosageform3,
      backendData.SuListing_Production_capabilities_dosageform4,
      backendData.SuListing_Production_capabilities_dosageform5,
      backendData.SuListing_Production_capabilities_dosageform6,
      backendData.SuListing_Production_capabilities_dosageform7,
      backendData.SuListing_Production_capabilities_dosageform8,
      backendData.SuListing_Production_capabilities_dosageform9,
      backendData.SuListing_Production_capabilities_dosageform10,
    ].filter(Boolean); // Removes undefined or null values

    const productionSections = [
      {
        name: "Manufacturing",
        tabs: dosageForms,
        content: dosageForms.map(
          (_, index) =>
            backendData[
              `SuListing_Detailed_Dosageform${index + 1}_manufacturing`
            ] || "N/A"
        ),
        equipment: dosageForms.map(
          (_, index) =>
            backendData[
              `SuListing_Detailed_mfgequipment_dosageform${index + 1}`
            ] || "N/A"
        ),
      },
      {
        name: "Packing",
        tabs: dosageForms,
        content: dosageForms.map(
          (_, index) =>
            backendData[
              `SuListing_Detailed_Dosageform${index + 1}_packaging`
            ] || "N/A"
        ),
        equipment: dosageForms.map(
          (_, index) =>
            backendData[
              `SuListing_Detailed_pkgequipment_dosageform${index + 1}`
            ] || "N/A"
        ),
      },
      {
        name: "Capacity",
        tabs: dosageForms,
        content: dosageForms.map(
          (_, index) =>
            backendData[`SuListing_Detailed_Dosageform${index + 1}_capacity`] ||
            "N/A"
        ),
      },
      {
        title: "Others",
        sections: (backendData.SuListing_Detailed_Others || []).map((name) => ({
          name,
        })),
      },
    ];

    const dataaccordian = [
      {
        title: "Production Capabilities",
        sections: productionSections,
      },
      {
        title: "Special Capabilities",
        sections: (
          backendData.SuListing_Detailed_Special_Capabilities || []
        ).map((name) => ({
          name,
        })),
      },
      {
        title: "Compliances",
        sections: (backendData.SuListing_Detailed_Compliances || []).map(
          (name) => ({
            name,
          })
        ),
      },
    ];

    return dataaccordian;
  };

  return (
    <div className="p14 backgroundColor">
      <BreadCrumbs array={urls} />
      {data?.SuListing_ID ? (
        <>
          <div className="px-5 py-4 mt-4 bg-white">
            <div className="ps_main mb-4">
              <div>
                <FirstButton
                  className="borderbtn"
                  buttonText="Back to Search Results"
                  onClick={() => navigate("/supplier-search")}
                />
              </div>
            </div>
            <div className="ps_main ">
              <div className="ps_main">
                <h1 className="fw-600">Supplier {data?.Plant_ID}</h1>
              </div>
              <div className="ps_main ">
                <FirstButton
                  className="btn me-4"
                  buttonText="Request Quote"
                  onClick={() => navigate(`/supplier-term-sheet/${id}`)}
                />
                <FirstButton
                  className="btn"
                  buttonText="Have questions?"
                  onClick={() => navigate("/contact-us")}
                />
              </div>
              <div></div>
            </div>
          </div>
          <div className="bg-white">
            <hr />
            <div className="row p-3">
              <div className="col-md-9 p-0">
                <div className="ph-spcardmain2-supplier bg-white m-3">
                  <div className="row ">
                    {/* Supplier Details */}
                    <div className="col-md-4 p-0">
                      <div className="p-3 mx-2">
                        <div style={{ flexDirection: "column" }}>
                          {data?.SuListing_Detailed_Manufacturing_Plant_location && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-3">
                                <PushPinIcon
                                  style={{ color: "#6a1ca5", fontSize: "24px" }}
                                />
                              </span>
                              {
                                data.SuListing_Detailed_Manufacturing_Plant_location
                              }
                            </p>
                          )}

                          {data?.SuListing_Filter_Searchpage_Years_Of_Operation && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-3">
                                <FlagCircleIcon
                                  style={{ color: "#6a1ca5", fontSize: "24px" }}
                                />
                              </span>
                              estd{" "}
                              {new Date(Date.now()).getFullYear() -
                                data.SuListing_Filter_Searchpage_Years_Of_Operation}
                            </p>
                          )}

                          {data?.SuListing_Detailed_Dosageforms_Annual_Capacity && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-3">
                                <img
                                  src={CapacityImage}
                                  style={{ width: "20px" }}
                                />
                              </span>
                              {
                                data.SuListing_Detailed_Dosageforms_Annual_Capacity
                              }
                            </p>
                          )}

                          {data?.SuListing_Detailed_RND_flag && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-3">
                                <ScienceIcon
                                  style={{ color: "#6a1ca5", fontSize: "24px" }}
                                />
                              </span>
                              R & D
                            </p>
                          )}

                          {data?.SuListing_Detailed_API_flag && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-3">
                                <img src={ApiImage} style={{ width: "20px" }} />
                              </span>
                              API
                            </p>
                          )}

                          {data?.SuListing_Detailed_Front_end_markets_flag && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-2">
                                <img
                                  src={frontEndImg}
                                  style={{ width: "20px" }}
                                />
                              </span>
                              Front end markets
                            </p>
                          )}
                          {data?.Plant_GMP_Year_of_Last_Inspection && (
                            <p
                              className="supplier-icon"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <span className="mb-1 me-2">
                                <AccessTimeIcon
                                  style={{ color: "#6a1ca5", fontSize: "24px" }}
                                />
                              </span>
                              Last inspected{" "}
                              {data?.Plant_GMP_Year_of_Last_Inspection}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Specialties and Dosage Forms */}
                    <div className="col-md-8 p-0">
                      <Card className="p-3 mx-2 mb-3">
                        <p className="location text-center  justify-content-center">
                          <span className="mb-1 me-3">
                            <SettingsSuggestRoundedIcon className="fs-20 me-4" />
                          </span>
                          Dosage forms
                        </p>

                        <div
                          className="row"
                          style={{ height: "100px", overflow: "scroll" }}
                        >
                          {data?.SuListing_Filter_Detailed_Dosageform?.map(
                            (item, index) => (
                              <div
                                key={index}
                                className=" p-0 mb-3"
                                style={{ maxWidth: "200px" }}
                              >
                                <div className="vpil  text-capitalize mx-3 fs-14 fw-500">
                                  {item}
                                  <div>
                                    {/* <CheckCircleIcon className="ms-3 text-info" /> */}
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </Card>
                      <Card className="p-3 mx-2">
                        <p className="location text-center  justify-content-center">
                          <span className="mb-1 me-3">
                            <StarsIcon className="fs-20 me-4" />
                          </span>
                          GMP accreditations
                        </p>
                        <div
                          className="row"
                          style={{ height: "100px", overflow: "scroll" }}
                        >
                          {data?.SuListing_Searchpage_Detailed_GMP?.map(
                            (item, index) => (
                              <div
                                key={index}
                                className=" p-0 mb-3"
                                style={{ maxWidth: "200px" }}
                              >
                                <div className="vpil text-capitalize mx-3  fs-14 fw-500">
                                  {item === "Others" &&
                                  data?.SuListing_Detailed_GMP ? (
                                    <Tooltip
                                      title={
                                        <span style={{ fontSize: "14px" }}>
                                          {data.SuListing_Detailed_GMP.split(
                                            ";"
                                          ).join(", ")}
                                        </span>
                                      }
                                      arrow
                                    >
                                      <span className="fs-14">{item}</span>
                                    </Tooltip>
                                  ) : (
                                    <span className="fs-14">{item}</span>
                                  )}

                                  <span>
                                    {/* <CheckCircleIcon className="ms-3 text-info" /> */}
                                  </span>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </Card>
                    </div>
                  </div>

                  {data?.SuListing_Detailed_CC_per_1000s_offer === null ||
                  data?.SuListing_Detailed_CC_per_1000s_offer === "null" ||
                  data?.SuListing_Detailed_CC_per_1000s_offer === "" ? (
                    <></>
                  ) : (
                    <h3
                      className="ppil fs-20 fw-500"
                      style={{ width: "fit-content" }}
                    >
                      $ {data?.SuListing_Detailed_CC_per_1000s_offer} cc per
                      {} {data?.SuListing_Detailed_CC_cost_UOM}
                    </h3>
                  )}
                </div>
                <div className="ph-spcardmain2-supplier  m-3">
                  {dataaccordian.map((item, index) => (
                    <Accordion
                      key={index}
                      className="my-4 p-2 border_radius shadow-none"
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        className="m-0"
                      >
                        <div className="col-md-6 m-0">
                          <h3 className="p-2 m-0">{item.title}</h3>
                        </div>
                      </AccordionSummary>

                      <AccordionDetails>
                        {item.title === "Production Capabilities" ? (
                          <>
                            {/* Single Tabs - Rendered once */}
                            <Tabs
                              value={selectedTab}
                              onChange={(_, newValue) => handleChange(newValue)}
                              variant="scrollable"
                              scrollButtons="auto"
                              className="mb-3"
                            >
                              {(item.sections[0]?.tabs || []).map((tab, i) => (
                                <Tab
                                  key={i}
                                  label={tab}
                                  sx={{
                                    mb: selectedTab === i ? 2.5 : 0,
                                  }}
                                />
                              ))}
                            </Tabs>

                            {item.sections
                              .slice(0, 3)
                              .map((section, secIndex) => {
                                const hasEquipment =
                                  section.name === "Manufacturing" ||
                                  section.name === "Packing";
                                const detailContent =
                                  section.content[selectedTab] || "N/A";
                                const equipmentContent =
                                  section.equipment?.[selectedTab] || "N/A";

                                return (
                                  <div key={secIndex} className="mb-4">
                                    <div
                                      className="d-flex "
                                      style={{
                                        gap: "14px",
                                      }}
                                    >
                                      <h5
                                        style={{
                                          width: hasEquipment ? "50%" : "100%",
                                        }}
                                        className="d-flex align-items-center mb-2"
                                      >
                                        {section.name}
                                      </h5>
                                      {(section.name === "Manufacturing" ||
                                        section.name === "Packing") && (
                                        <h5 className="mb-2">Equipment</h5>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: hasEquipment
                                          ? "row"
                                          : "column",
                                        gap: "16px",
                                      }}
                                    >
                                      <Card
                                        className="p-3 mb-2"
                                        style={{
                                          width: hasEquipment ? "50%" : "100%",
                                        }}
                                      >
                                        <p className="fs-14 mb-0">
                                          {detailContent}
                                        </p>
                                      </Card>

                                      {hasEquipment && (
                                        <Card
                                          className="p-3 mb-2"
                                          style={{ width: "50%" }}
                                        >
                                          {/* <strong>Equipment:</strong> */}
                                          <p className="fs-14 mb-0">
                                            {equipmentContent}
                                          </p>
                                        </Card>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}

                            {/* Handle "Others" section if it exists */}
                            {item.sections[3]?.title === "Others" && (
                              <div className="mb-3">
                                <h5 className="mb-2">
                                  {item.sections[3].title}
                                </h5>
                                {item.sections[3].sections.map(
                                  (subSection, subIndex) => (
                                    <Card key={subIndex} className="p-3 mb-2">
                                      <p className="fs-14">{subSection.name}</p>
                                    </Card>
                                  )
                                )}
                              </div>
                            )}
                          </>
                        ) : (
                          // Handle other accordion sections like Special Capabilities & Compliances
                          item.sections.map((section, secIndex) => (
                            <Card key={secIndex} className="p-3 mb-2">
                              <p className="fs-14">{section.name}</p>
                            </Card>
                          ))
                        )}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </div>
              <div className="col-md-3 p-0">
                <h2>Related products</h2>
                {relateddata &&
                  relateddata.map((sitem, index) => (
                    <div
                      className="ph-spcardmain2-supplier card-hover "
                      onClick={() => navigate(`/product-details/${sitem?._id}`)}
                    >
                      <div className="d-flex">
                        <h2 className="fs-20 fw-600 sidebar_close title-hover-2 ">
                          {sitem?.ListingTitle}
                        </h2>
                      </div>
                      <p className="ph-cardspp-sub">
                        - Code:{sitem?.ListingCode}
                      </p>
                      <div className="ph-cardspp-sub">
                        -{" "}
                        {[
                          sitem?.productDetails?.doseForm,
                          sitem?.productDetails?.strengths,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      </div>
                      <div className="ph-cardspp-sub">
                        -{" "}
                        {(
                          sitem?.dealContours?.availableGeographies ?? []
                        )?.join(", ")}
                      </div>
                      <div className="ph-cardspp-sub">
                        - {sitem?.productDetails?.dossierStatus}
                      </div>
                      <div className="ph-cardspp-sub">
                        - {(sitem?.Supply ?? [])?.join(", ")}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <FirstButton
            className="btn my-2"
            buttonText="Request Quote"
            width="100%"
            onClick={() => navigate(`/supplier-term-sheet/${id}`)}
          />
        </>
      ) : (
        <>
          <Card className="px-2 w100">
            <div className="d-flex flex-column align-items-center p-3">
              <img src={noData} style={{ width: "25%", height: "auto" }} />

              <h2 className="text-center light-text-color">
                Searched Supplier does not exist...
              </h2>

              <FirstButton
                className="borderbtn"
                buttonText="Back to Search Results"
                onClick={() => navigate("/supplier-search")}
              />
            </div>
          </Card>
        </>
      )}
    </div>
  );
};

export default SupplierDetails;
